/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import styled from "styled-components";

import {WealthyEnv} from "helpers";

const headingTagIcon = `${WealthyEnv.BROKING_CDN_URL}/heading-tag.png`;

const SectionTitle = ({children}) => {
  return (
    <SectionHeading>{children}</SectionHeading>
  );
};

const SectionHeading = styled.h2`
  font-size: 3.2rem;
  padding-left: 1.2rem;

  @media (max-width: 768px) {
    font-size: 2.4rem;
  }

  @media (max-width: 576px) {
    font-size: 1.6rem;
    padding-left: 0;
  }
`;

export default SectionTitle;
